<template>
    <div class="header-menu-opener">
        <div class="flex-column align-right ml-3">
            <span class="text-light-2 text-size-10">{{ user.firstName }} {{ user.lastName }}</span>
            <span class="text-light-1 text-size-10">{{ tenant.name }}</span>
        </div>

        <b-avatar :src="avatarUrl" class="ml-4 mr-3" />

        <i class="fa" :class="opened ? 'fa-chevron-up' : 'fa-chevron-down'" />
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { DEFAULT_AVATAR } from '../../business/const'

export default {
    name: 'HeaderMenuOpener',
    props: {
        opened: {
            type: Boolean,
            required: true
        }
    },
    computed: {
        ...mapState({
            selectedTenant: state => state.common.selectedTenant,
            user: state => state.common.user
        }),
        tenant() {
            if (this.selectedTenant._id) {
                return this.selectedTenant
            } else {
                return (this.user.tenants && this.user.tenants[0]) || {}
            }
        },
        avatarUrl() {
            const { imageUrl } = this.user
            const noImage = !imageUrl || imageUrl === 'empty' || imageUrl.includes('licdn.com')

            return noImage ? DEFAULT_AVATAR : imageUrl
        }
    }
}
</script>

<style lang="scss" scoped>
.header-menu-opener {
    display: flex;
    align-items: center;
    margin-left: auto;
    margin-right: 1rem;

    .b-avatar {
        height: 2rem !important;
        width: 2rem !important;

        img {
            height: 100%;
            width: 100%;
        }
    }

    .fa-chevron-up,
    .fa-chevron-down {
        color: $light-3;
        font-size: 10pt;
    }
}
</style>
